import React from 'react';
import { useParams } from 'react-router-dom';
import ProductDetail from '../components/store/ProductDetail';
import './StorePage.css';

const StoreGoods = () => {
  const { goodsSeq } = useParams();
  return (
    <div className="container">
      {/* Header 제거됨 */}
      <ProductDetail goodsSeq={goodsSeq} />

    </div>
  );
};

export default StoreGoods;
